import BaseApiService from './BaseApiService';

class ViewDetailsApiService extends BaseApiService {
    constructor() {
        super('details');
    }

    async get({ drugId }) {
        const response = await this.request({ method: 'get', url: `/${drugId}` });
        return response && response.details ? response.details : {};
    }
}

export default new ViewDetailsApiService();
